// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ai-data-management.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ai-data-management',
  title: 'Govern data quality, provenance and preparation for AI systems',
  description:
    'Confirm that data used for training, validation, testing and operation of AI systems is governed for quality, relevance, representativeness and freedom from bias, with documented provenance (ISO/IEC 42001 Annex A.7.2–A.7.6). Data preparation activities (cleaning, labelling, aggregation, synthetic data generation) shall be documented and applied consistently with the intended purpose of the AI system. Review the AI data-governance standard, sample data provenance records, and the data-quality evaluation results for active datasets.',
  category: 'technical',
  scfIds: ['SCF-AIG-009'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'AI data-governance standard is published' },
    { type: 'document-approved', description: 'Standard has been approved' },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
